'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

OrganizationUsersConfig=class OrganizationUsersConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('organizationUsers');
$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=OrganizationUsersConfig;
//# sourceMappingURL=organizationUsersConfig.js.map
